import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentFooterInfo } from '../../model/content/contentfooter.model';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';

declare let delta: any;

@Component({
  selector: 'ngc-information',
  templateUrl: './information.component.html'
})
export class InformationComponent implements OnDestroy, OnInit {
  public contentInfo: ContentFooterInfo;
  contentServiceHeaderFooterSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private contentService: ContentHeaderFooterService,
    private cdf: ChangeDetectorRef
  ) {
    this.contentInfo = new ContentFooterInfo();
  }

  ngOnInit() {
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      this.contentInfo = data.footer.info;
                      this.cdf.detectChanges();
                    }
                  },
                  (err) => {
                    // delta.utils.logger.logMessage('Caught Error: ' + err, 'error');
                  }
                );
          }
        }
      });
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }
}
